var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("FormSubmitPopup", {
    attrs: { title: _vm.$t("edit"), rightMethod: _vm.onSubmitted, medium: "" },
    on: {
      popupClose: function($event) {
        return _vm.$emit("input", false)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "input",
        fn: function() {
          return [
            _c(
              "v-container",
              [
                _c("v-layout", { staticClass: "headline" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("carrier")) + ": \n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-radio-group",
                      {
                        attrs: { column: false },
                        model: {
                          value: _vm.carrier,
                          callback: function($$v) {
                            _vm.carrier = $$v
                          },
                          expression: "carrier"
                        }
                      },
                      _vm._l(Object.entries(_vm.carrierMap), function(item) {
                        return _c("v-radio", {
                          key: item[0],
                          attrs: { label: "" + item[1], value: item[0] }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-layout", { staticClass: "headline" }, [
                  _vm._v("\n        " + _vm._s(_vm.$t("type")) + ": \n      ")
                ]),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c("v-switch", {
                      attrs: {
                        label: _vm.$t(_vm.isInbound ? "inbound" : "outbound")
                      },
                      model: {
                        value: _vm.isInbound,
                        callback: function($$v) {
                          _vm.isInbound = $$v
                        },
                        expression: "isInbound"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("v-layout", { staticClass: "headline" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("serviceType")) + ": \n      "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-radio-group",
                      {
                        attrs: { column: false },
                        model: {
                          value: _vm.serviceType,
                          callback: function($$v) {
                            _vm.serviceType = $$v
                          },
                          expression: "serviceType"
                        }
                      },
                      _vm._l(Object.entries(_vm.serviceTypeMap), function(
                        item
                      ) {
                        return _c("v-radio", {
                          key: item[0],
                          attrs: { label: "" + item[1], value: item[0] }
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ]
        },
        proxy: true
      }
    ]),
    model: {
      value: _vm.value,
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ae712d64", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ae712d64","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrescanHistoryEditPopup.vue
// module id = null
// module chunks = 